
import { Module } from '@nestjs/common';
import { VendorsController } from './vendor-registration.controller';
import { VendorRegService } from './vendor-registration.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { VendorsEntity } from './entity/vendors.entity';
@Module({
    imports: [
        TypeOrmModule.forFeature([
            VendorsEntity
        ])
    ],
  controllers: [VendorsController],
  providers: [VendorRegService]
})
export class VendorModule {}
